import React, {useEffect, useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useNavigate} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {useApiSearchAdminClassroom} from "@/api/classroom";
import IranMap from "@/components/map/Map";
import PopupMapAdminClassroom from "@/pages/admin/classroom/map/_section/popup";

function AdminClassroomMapPage(props) {
    const navigate = useNavigate();
    const [myPoints, setMyPoints] = useState([])
    const [itemClicked, setItemClicked] = useState({})
    const {data: classroomList, isPending} = useApiSearchAdminClassroom({per_page: 1000})

    useEffect(() => {
        if (classroomList?.data?.data?.length > 0) {
            classroomList?.data?.data?.map(item => {
                setMyPoints(classroomList?.data?.data)
            })
        }
    }, [classroomList]);

    return (
        <AdminLayout backTo={URLS.admin.classroom.dashboard} pageTitle={'لیست محل‌های برگزاری کلاس'}>
            <div className={' p-2 rounded-lg '}>
                <h2 className={'my-1 font-bold'}>نمایش محل‌های برگزاری کلاس از روی نقشه</h2>

                <div className={'h-[600px]'}>
                    <IranMap
                        points={myPoints}
                        clickHandler={false}
                        setItemClicked={setItemClicked}
                        popupElement={<PopupMapAdminClassroom/>}
                    />
                </div>

            </div>
        </AdminLayout>
    );
}

export default AdminClassroomMapPage;


